import { gsap } from './gsap';

export function initMobileMenu() {
    const menu    = document.querySelector( '.mobile-menu' );
    const inner   = menu?.querySelector( '.mobile-menu__inner' );
    const items   = menu?.querySelectorAll( '.mobile-menu__list a' );
    const lang    = menu?.querySelector( '.mobile-menu__lang' );
    const burger  = document.querySelector( '.site-header__burger' );
    const closeBtn = menu?.querySelector( '.mobile-menu__close' );

    if ( ! menu || ! burger ) return;

    let isOpen = false;

    const tl = gsap.timeline( { paused: true, defaults: { ease: 'power3.out' } } );

    tl.to( inner, { x: '0%', duration: 0.55, ease: 'power4.out' } )
      .to( items, { y: 0, opacity: 1, duration: 0.5, stagger: 0.07 }, '-=0.3' )
      .to( lang,  { y: 0, opacity: 1, duration: 0.4 }, '-=0.2' );

    function open() {
        isOpen = true;
        menu.classList.add( 'is-open' );
        menu.setAttribute( 'aria-hidden', 'false' );
        document.body.style.overflow = 'hidden';
        burger.setAttribute( 'aria-expanded', 'true' );
        tl.play();
    }

    function close() {
        isOpen = false;
        burger.setAttribute( 'aria-expanded', 'false' );
        tl.reverse().then( () => {
            menu.classList.remove( 'is-open' );
            menu.setAttribute( 'aria-hidden', 'true' );
            document.body.style.overflow = '';
        } );
    }

    burger.addEventListener( 'click', () => ( isOpen ? close() : open() ) );
    closeBtn?.addEventListener( 'click', close );

    document.addEventListener( 'keydown', ( e ) => {
        if ( e.key === 'Escape' && isOpen ) close();
    } );

    // Close on nav link click (same-page or internal navigation)
    items?.forEach( ( a ) => a.addEventListener( 'click', close ) );
}
